import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

function printParams(req: HttpRequest<unknown>): string {
    const keys = req.params.keys();
    if (keys.length === 0) {
        return '';
    }
    return keys.map((k) => `${k}=${req.params.getAll(k)?.join(',')}`).join('&');
}

function printBody(body: unknown): unknown {
    if (body instanceof FormData) {
        return '[FormData]';
    }
    if (body instanceof Blob) {
        return '[Blob]';
    }
    return body;
}

export const debugInterceptor: HttpInterceptorFn = (req, next) => {
    if (environment.production) {
        return next(req);
    }

    const { method, url } = req;
    const params = printParams(req);
    const payload = printBody(req.body);

    console.log(`[DEBUG] ➜ ${method} ${url}`);
    if (params) {
        console.log('  params: ', params);
    }
    console.log('  payload:', payload);

    return next(req).pipe(
        tap({
            next: (event) => {
                if (event instanceof HttpResponse) {
                    console.log(`[DEBUG] ✓ ${method} ${url} → ${event.status}`);
                    console.log('  response:', printBody(event.body));
                }
            },
            error: (error) => {
                if (error instanceof HttpErrorResponse) {
                    console.log(`[DEBUG] ✗ ${method} ${url} → ${error.status} ${error.statusText}`);
                    console.log('  error body:', printBody(error.error));
                } else {
                    console.log(`[DEBUG] ✗ ${method} ${url}`);
                    console.log('  error:', error);
                }
            },
        }),
    );
};
